import { h, render } from 'preact';
import InactivePage from '@/base/page/InactivePage';
import Beans3 from '@/beans';
import { i18n, Utils, riperStorage } from '@/base/helpers';
import { Widget, Flow, Tabulator } from './helpers';
import ActivePage from './views/page/ActivePage';
import Popup from './views/popup/Popup';

const Bamboo = {
  Actions: {
    onRegister: () => riperStorage.onRegister(),
    onLogin: () => riperStorage.onLogin(),
    onAbout: () => riperStorage.onAboutBamboo(),
    onClosePopup: () => Bamboo.Popup.close(),
  },
  init({ riperDisplay: display, account }) {
    const refCode = Utils.getUrlParam('_br');
    Bamboo.Referral.init();

    Flow.init(account);

    if (account) {
      /** Populate links for referral sharing */
      account.share = {
        facebook: `${account.referral_link}-facebook`,
        twitter: `${account.referral_link}-twitter`,
      };
      if (Bamboo.Referral._br) Bamboo.Referral.commit(account);
    }

    if (refCode) {
      Bamboo.Popup.show('rule:bamboo:display_popup_invite', {
        coupon_value: display.popup.coupon_value,
      });
    }

    if (display.is_active && display.beans_referral_referrer > 0) Beans3.require('snow').then(Widget.init);

    Bamboo.View.renderPage();
  },
};

Bamboo.Popup = {
  _instance: null,
  _setContainers() {
    return new Promise(function (resolve) {
      const action = () => resolve(Beans3._utils.getOrCreateContainer(document.body, 'beans-bamboo-popup'));
      document.body ? action() : document.addEventListener('DOMContentLoaded', action);
    });
  },

  render(ruleUid, variables) {
    Bamboo.Popup._setContainers().then(function (container) {
      container.style.display = 'block';
      Bamboo.Popup._instance = <Popup ruleUid={ruleUid} variables={variables} />;
      return render(Bamboo.Popup._instance, container);
    });
  },

  show(ruleUid, variables) {
    if (!riperStorage.riperDisplay.is_active && !Beans3.previewSession.isActive()) return;
    this.render(ruleUid, variables);
  },

  close() {
    document.getElementById('bamboo-popup-container').style.display = 'none';
  },
};

Bamboo.View = {
  setPageContainer() {
    /** Referral Program Page
     * Display the referral program page.
     */
    function _setContainers(resolve) {
      const setPageContainers = (iteration) => {
        const pageContainer = riperStorage.args.pagePlaceholder || document.getElementById('bamboo-referral-page');
        if (pageContainer) {
          resolve(pageContainer);
        } else if (iteration < 3) {
          setTimeout(() => setPageContainers(iteration + 1), 2000);
        } else {
          resolve(null);
        }
      };
      setPageContainers(0);
    }
    return Utils.createDOMPromise(_setContainers);
  },
  renderPage() {
    return this.setPageContainer().then((pagePlaceholder) => {
      if (pagePlaceholder) {
        const display = riperStorage.riperDisplay;
        const account = riperStorage.account;
        pagePlaceholder.innerHTML = '';
        const Strings = Utils.parseI18n(i18n._Strings, {});
        if (display.is_active || Beans3.previewSession.isActive()) {
          render(
            <ActivePage
              account={account}
              Strings={Strings}
              tabulator={new Tabulator(account)}
              onRegister={() => Flow.redirectOnAuthToProgramPage(riperStorage.onRegister)}
              onLogin={() => Flow.redirectOnAuthToProgramPage(riperStorage.onLogin)}
            />,
            pagePlaceholder
          );
        } else {
          render(<InactivePage message={Strings.page.inactive} />, pagePlaceholder);
        }
      }
    });
  },
};

Bamboo.Referral = {
  _br: Beans3._session.get('_br'),
  init() {
    const refCode = Utils.getUrlParam('_br');
    if (refCode) {
      Bamboo.Referral._br = refCode;
      Beans3._session.set('_br', refCode);
    }
  },
  commit(account) {
    if (!Bamboo.Referral._br) return;
    Beans3.post({
      path: `${Beans3._trellis}/referral/`,
      namespace: 'trellis',
      data: { account: account.id, _br: Bamboo.Referral._br },
    })
      .then((referral) => {
        account.referral = referral;
        Beans3._session.set('_br', '');
        Bamboo.Referral._br = '';
      })
      .catch(console.log);
  },
};

export default Bamboo;
